module.exports = __webpack_public_path__ + "static/img/culturePic1.260f7ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/culturePic1.jpg
// module id = cSIR
// module chunks = 0